import { Outlet } from 'react-router-dom';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { AppShell, type NavItem } from './AppShell';

const navItems: NavItem[] = [
  { label: 'Soutěže', to: '/recorder', icon: <EmojiEventsIcon />, exact: true },
];

export const RecorderLayout = () => (
  <AppShell navItems={navItems} title="ZAPISOVATEL">
    <Outlet />
  </AppShell>
);
